<template>
    <div class="pa-0">
      <div class="interaction-section-body">
        <hb-form
          label="Future Invoice"
          :description="activeForm == 'Future Invoice' ? 'Allow voiding future invoices' : ''"
          :active.sync="activeForm"
          editable
          :empty="false"
          @cancel="handleEmittedCancel"
          @save="handleEmittedSave"
        >
          <template v-slot:display>
            <v-col class="ma-0 pa-0" cols="12" sm="12">
              {{ futureVoidSetting ? 'Yes' : 'No' }}
            </v-col>
          </template>
          <template v-slot:edit>
            <div>
              <hb-switch
                right
                v-model="futureVoidSetting"
                :label="futureVoidSetting ? 'Yes' : 'No'"
              />
            </div>
          </template>
        </hb-form>
  
        <hb-form
          label="Current Invoice"
          :description="activeForm == 'Current Invoice' ? 'Select when you can no longer void a current invoice' : ''"
          :active.sync="activeForm"
          editable
          :empty="false"
          @cancel="handleEmittedCancel"
          @save="handleEmittedSave"
        >
          <template v-slot:display>
            <v-col class="ma-0 pa-0" cols="12" sm="12">
              {{ currentVoid.type === 'EOB' ? 'End Of Billing Period' : `Number Of Days From Due Date: ${currentVoid.value}` }}
            </v-col>
          </template>
          <template v-slot:edit>
            <v-radio-group v-model="currentVoid.type" dense hide-details>
              <v-radio value="EOB">
                <template v-slot:label>End Of Billing Period</template>
              </v-radio>
              <v-radio value="nod">
                <template v-slot:label>
                  <v-row class="pa-0 ma-0 align-center">
                    <span class="mt-1 mr-2">Number Of Days From Due Date</span>
                    <v-text-field
                      style="max-width: 60px;"
                      type="number"
                      min="1"
                      max="999"
                      dense
                      hide-details
                      v-model="currentVoid.value"
                      v-validate="currentVoid.type === 'nod' ? 'required|numeric|min_value:1|max_value:999' : ''"
                      data-vv-name="currentVoidDays"
                      data-vv-as="Current Void Days"
                      :error-messages="errors.collect('currentVoidDays')"
                    />
                  </v-row>
                </template>
              </v-radio>
            </v-radio-group>
          </template>
        </hb-form>
  
        <hb-form
          label="Closed Invoice"
          :description="activeForm == 'Closed Invoice' ? 'Select when you can no longer void a past invoice' : ''"
          :active.sync="activeForm"
          editable
          :empty="false"
          @cancel="handleEmittedCancel"
          @save="handleEmittedSave"
        >
          <template v-slot:display>
            <v-col class="ma-0 pa-0" cols="12" sm="12">
              {{ pastVoid.type === 'EOM' ? 'Until Close Of Billing Period Month' : `Number Of Days From End Date: ${pastVoid.value}` }}
            </v-col>
          </template>
          <template v-slot:edit>
            <v-radio-group v-model="pastVoid.type" dense hide-details>
              <v-radio value="EOM">
                <template v-slot:label>Until Close Of Billing Period Month</template>
              </v-radio>
              <v-radio value="nod">
                <template v-slot:label>
                  <v-row class="pa-0 ma-0 align-center">
                    <span class="mt-1 mr-2">Number Of Days From End Date</span>
                    <v-text-field
                      style="max-width: 60px;"
                      type="number"
                      min="1"
                      max="999"
                      dense
                      hide-details
                      v-model="pastVoid.value"
                      v-validate="pastVoid.type === 'nod' ? 'required|numeric|min_value:1|max_value:999' : ''"
                      data-vv-name="pastVoidDays"
                      data-vv-as="Past Void Days"
                      :error-messages="errors.collect('pastVoidDays')"
                    />
                  </v-row>
                </template>
              </v-radio>
            </v-radio-group>
          </template>
        </hb-form>

        <hb-global-notification
        v-model="snackbar"
        :type="type"
        :list="type === 'error' ? errorsList : []"
        :description="description"
        >
        </hb-global-notification>
  
      </div>
    </div>
  </template>
  
  <script>
  import api from "../../../assets/api";
  
  export default {
    name: "VoidSettings",
    data() {
      return {
        snackbar: false,
        notificationModal: false,
        type: '',
        description: '',
        errorsList: [],
        activeForm: '',
        futureVoidSetting: false,
        currentVoid: { type: "EOB", value: "" },
        pastVoid: { type: "EOM", value: "" }
      };
    },
    created() {
      this.fetchVoidSettings();
    },
    methods: {
        setErrors(val) {
            if(val.length) {
                this.errorsList = val;
            }
        },
        showNotification() {
            this.description = "There are errors in your form, correct them before continuing."
            this.type = 'error';
            this.snackbar = true;
            return;
        },
        hideNotification() {
            this.errorsList = [];
            this.description = ""
            this.type = 'cancel';
            this.snackbar = false;
        },
        handleEmittedCancel(label){
            this.hideNotification();
            this.fetchVoidSettings();
        },
        async handleEmittedSave(label) {
            const valid = await this.$validator.validateAll();
            if (valid) {
                if (this.errors.items.length) return;
                this.saveVoidSettings();
                this.activeForm = '';
            }
        },
        async fetchVoidSettings() {
            try {
                const response = await api.get(this, api.SETTINGS + 'void-setting');
                this.futureVoidSetting = response.void.future == true;
                this.currentVoid = {
                    type: isNaN(response.void.current) ? "EOB" : "nod",
                    value: isNaN(response.void.current) ? 0 : parseInt(response.void.current)
                };
                this.pastVoid = {
                    type: isNaN(response.void.past) ? "EOM" : "nod",
                    value: isNaN(response.void.past) ? 0 : parseInt(response.void.past)
                };
            } catch (error) {
                console.error("Error fetching void settings:", error);
            }
        },
        async saveVoidSettings() {
            try {
                const payload = {
                    void: {
                        future: this.futureVoidSetting ? true : false,
                        current: this.currentVoid.type === "EOB" ? "EOB" : this.currentVoid.value,
                        past: this.pastVoid.type === "EOM" ? "EOM" : this.pastVoid.value
                    }
                };

                console.log("Payload:", payload);
                await api.put(this, api.SETTINGS + "void-setting", payload);
            } catch (err) {
                console.error("Error saving void settings:", err);
            }
        }
    },
    watch: {
        "errors.items"(val) {
            if(val.length) {
                this.setErrors(val);
            } else {
                this.hideNotification();
            }
        }
    }
  };
  </script>
  